import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import Slider from 'react-slick';
import CourseCard from '../../../components/CourseCard';

const GridCarousel = ({ title, data, preRef, preSrc = null, imgref, variables = null }) => {
  const windowWidth = window.innerWidth;
  const settings_courses = {
    autoplay: false,
    dots: false,
    speed: 500,
    slidesToShow: (windowWidth <= 987 ? 2 : 4),
    slidesToScroll: (windowWidth <= 987 ? 2 : 4)
  };
  const course_trails = variables && variables.course_trails ? variables.course_trails : false;

  return (
    <Grid className="rowCarousel">
      <Row>
        <Col md={12}>
          <h2>{title}</h2>
        </Col>
      </Row>
      <Slider
        {...settings_courses}
        infinite={
          data.length > 3
            ? true
            : false
        }
      >
        {data.map((item) => (
          <CourseCard
            key={item.id} //
            min={imgref.current ? imgref.current.height : ''}
            item={item}
            href={preRef + item.id}
            src={preSrc ? preSrc + item.thumbnail : item.thumbnail}
            variables={{ course_trails:course_trails }}
          />
        ))}
      </Slider>
    </Grid>
  );
};

export default GridCarousel;



// WEBPACK FOOTER //
// ./src/views/Home/components/GridCarousel.jsx